export const flipVertical = (self, el) => {
  self._checkNoProcessingTask();
  const working_layer = self._getWorkingLayerThrowable();
  const selection = self._getSelectionThrowable();
  const scale_transform = self._getScaleTransformThrowable();
  const selector_controller = self._getSelectorControllerThrowable();
  if (!working_layer.getIsChildGraphicsEl(el)) {
    throw new Error(`layer 엘리먼트의 자식 엘리먼트만 뒤집을 수 있습니다.`);
  }
  scale_transform.flipVertical(el);
  const selected_els = selection.getSelectedEls();
  if (selected_els.has(el)) {
    selector_controller.syncWith(selected_els);
  }
};
